import React from 'react';

interface HeaderProps {
  viewType: 'booked' | 'pending';
  setViewType: (type: 'booked' | 'pending') => void;
  search: string;
  setSearch: (value: string) => void;
  openModal: () => void;
}

const Header: React.FC<HeaderProps> = ({ viewType, setViewType, search, setSearch, openModal }) => (
  <div className="sticky sm:top-0 -top-4 z-10 bg-cardClr backdrop-blur-sm border-b border-cardClr-secondary">
    <div className="px-4 lg:px-8 py-3 lg:py-4 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
        <button
          onClick={openModal}
          className="bg-slate-900 hover:bg-primary text-white hover:text-textClr-active font-medium py-2 px-4 rounded-lg flex items-center gap-2 text-sm"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          Create Meeting
        </button>

        <div className="flex gap-1 p-0.5 bg-cardClr-secondary rounded-lg">
          <button
            className={`flex-1 px-4 py-2 rounded-md text-xs font-medium ${
              viewType === 'booked'
                ? 'bg-cardClr text-cardClr-text shadow-sm'
                : 'text-cardClr-textSecondary hover:text-tabClr-active'
            }`}
            onClick={() => setViewType('booked')}
          >
            Scheduled
          </button>
          <button
            className={`flex-1 px-4 py-2 rounded-md text-xs font-medium ${
              viewType === 'pending'
                ? 'bg-cardClr text-cardClr-text shadow-sm'
                : 'text-cardClr-textSecondary hover:text-tabClr-active'
            }`}
            onClick={() => setViewType('pending')}
          >
            Unscheduled
          </button>
        </div>
      </div>

      <div className="relative w-full lg:w-72">
        <input
          type="text"
          placeholder={`Search ${viewType} meetings...`}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full border border-slate-200 text-cardClr-text rounded-lg py-2.5 px-3 text-sm placeholder-cardClr-textSecondary focus:outline-none focus:ring-2 focus:ring-slate-500 focus:border-slate-500 bg-cardClr-secondary"
        />
      </div>
    </div>
  </div>
);

export default Header;
